import * as api from '../../api/api-carta-cia-tercero-modal';
import { 
    GET_CONFIG_FORM16,
    GET_DATOS_CARTA_CIA_TERCERO,
    GET_COMBO_VEHICULOS,
    GET_COMBO_MARCAS,
    GET_COMBO_COMPANIAS,
    GET_MONTOS,
    POST_ACTUALIZAR_CIA,
    GET_SOLICITUD_DESCUENTO,
    SET_LOADING_CARTA,
    GET_PARAMETROS
   
} from '../types';

export const configuracionFormAction16 = (query) => ({
    type: GET_CONFIG_FORM16,
    payload: api.getConfiguracionForm16(query)
});
export const obtenerDatosCartaCIATercero = (query) => ({
    type: GET_DATOS_CARTA_CIA_TERCERO,
    payload: api.getDatosCartaCIATercero(query)
});
export const obtenerParametroFecha = (query) => ({
    type: GET_PARAMETROS,
    payload: api.getParametrosFecha(query)
});
export const obtenerComboTipoVehiculos = (query) => ({
    type: GET_COMBO_VEHICULOS,
    payload: api.getTipoVehiculos(query)
});
export const obtenerComboMarcas = (query) => ({
    type: GET_COMBO_MARCAS,
    payload: api.getMarcas(query)
});
export const obtenerComboCompanias= (query) => ({
    type: GET_COMBO_COMPANIAS,
    payload: api.getcompanias(query)
});
export const obtenerMontos= (query) => ({
    type: GET_MONTOS,
    payload: api.getMontosInformados(query)
});
export const postActualizarCIATercero= (data) => ({
    type: POST_ACTUALIZAR_CIA,
    payload: api.postActualizarCIA(data)
});
export const obtenerSocitudDescuento = (query) => ({
    type: GET_SOLICITUD_DESCUENTO,
    payload: api.getSolicitudDescuento(query)
});
export const cambiarLoadingCarta = (loading) => ({
    type: SET_LOADING_CARTA,
    payload: loading
});